import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { Request } from '@lsq-frontend/angular-shared/api-service';
import {
    AcceptEulaForDashboardUserService,
    GetEulaAcceptedDateForUserService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';

@Injectable({
    providedIn: 'root'
})
export class EulaService {
    private _eulaIsAcceptedSubject = new ReplaySubject<boolean>(1);
    public eulaIsAccepted$ = this._eulaIsAcceptedSubject.asObservable();

    constructor(
        private _userService: UserService,
        private _acceptEulaForDashboardUserService: AcceptEulaForDashboardUserService,
        private _getEulaAcceptedDateForUserService: GetEulaAcceptedDateForUserService
    ) {
        SingletonServiceGuard.register('EulaService');
        this._userService.user$.subscribe(async (user) => {
            if (user) {
                await this.fetchEulaAcceptedDate();
            }
        });
    }

    public async fetchEulaAcceptedDate(): Promise<void> {
        const eulaAcceptedDate = (
            await this._getEulaAcceptedDateForUserService.executeOnce(new Request())
        ).eulaAcceptedDate;
        this._eulaIsAcceptedSubject.next(!!eulaAcceptedDate);
    }

    public async acceptEula(): Promise<void> {
        await this._acceptEulaForDashboardUserService.executeOnce({});
    }
}
